import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Select from "react-select/creatable";

import { auth } from "../../utils/auth";
import { withRequest } from "../../utils/request";
import {
    formatDate,
    toast,
    formatCurrency,
    getLink,
} from "../../utils/helpers";
import { apiUrl } from "../../utils/apiUrl";
import ItemsCompra from "./ItemsCompra";
import Loader from "../general/Loader";
import dayjs from "dayjs";

class Create extends Component {
    state = {
        errors: {},
        compra: {},
        contactos: [],
        items: [],
        grupos: [],
        almacenes: [],
        compraItems: [{ id: Date.now(), subtotal: 0, itbis: 0 }],
        useItbis: 'aplicado',
        itbis: 1.18,
        total: 0,
        saving: false,
    };
    componentDidMount() {
        this.getTable("contactos");
        this.getTable("items");
        this.getTable("grupos");
        this.getTable("almacenes");
    }
    getTable = async (url = null) => {
        const table = await this.props.request(url);

        if (table.data) {
            this.setState({
                [url]: table.data,
            });
            this.setState({
                loading: false,
            });
        }
    };
    createCompra = async (event) => {
        event.preventDefault();

        this.setState({
            saving: true,
        });

        const token = auth.getToken();
        const data = new FormData(event.target);

        const res = await fetch(apiUrl("compras"), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/compras"));
            this.setState({
                saving: false,
            });
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message, saving: false });
            toast("Por favor revisa todos los campos", "error");
        }
    };
    addItem = () => {
        this.setState({
            compraItems: [...this.state.compraItems, { id: Date.now() }],
        });
    };
    removeItem = (item) => {
        this.setState({
            compraItems: this.state.compraItems.filter((i) => i.id !== item),
        });
    };
    calcularItbis = (items) => {
        return items.reduce((accum, item) => {
            return accum + parseFloat(item.itbis);
        }, 0)
    };
    calcularSubtotal = (items) => {
        return items.reduce((accum, item) => {
            return accum + parseFloat(item.subtotal);
        }, 0)
    };
    calcularTotal = (total, itbis) => {
        return total + itbis;
    };
    updateTotal = async (id = null, value = null, itbis = 0) => {
        await this.setState({
            compraItems: this.state.compraItems.map((item) => {
                if (item.id === id) {
                    item.subtotal = value;
                    item.itbis = itbis;
                }
                return item;
            }),
        });
    };
    changeItbis = async (e) => {
        const useItbis = e.target.value;
        await this.setState({useItbis});
        if (useItbis === 'no-aplicado') {
            await this.setState({
                itbis: 0.18,
            });
        }
        if (useItbis === 'aplicado') {
            await this.setState({
                itbis: 1.18,
            });
        }
        if (useItbis === 'no-aplica') {
            await this.setState({
                itbis: 0,
            });
        }
        this.triggerUpdateItbis();
    };
    triggerUpdateItbis = () => {
        const event = new Event('update-itbis');
        window.dispatchEvent(event);
    }
    render() {
        const {
            errors,
            compra,
            contactos,
            compraItems,
            items,
            grupos,
            almacenes,
            useItbis,
            itbis,
            saving,
        } = this.state;
        const { toggle } = this.props;

        const subtotal = this.calcularSubtotal(compraItems);
        const totalitbis = this.calcularItbis(compraItems);
        const total = this.calcularTotal(subtotal, totalitbis);

        const almacenPrincipal = almacenes.filter(
            (almacen) => almacen.principal
        )[0];

        return (
            <div className='crear-compra'>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Nueva Compra</span>
                    </h1>
                </div>
                <form
                    method='post'
                    onSubmit={this.createCompra}
                    onKeyUp={this.preventEnter}
                    className='row'>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            Suplidor:
                        </label>
                        {contactos.length > 0 && (
                            <Select
                                name='contacto_id'
                                isClearable={true}
                                defaultValue={
                                    compra.contacto && {
                                        value: compra.contacto,
                                        label: compra.contacto,
                                    }
                                }
                                options={contactos.map((contacto) => ({
                                    value: contacto.nombre,
                                    label: contacto.nombre,
                                }))}
                            />
                        )}
                        {errors.contacto_id && (
                            <small className='help-blockParams form-Text'>
                                {errors.contacto_id[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            Fecha:
                        </label>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha'
                            name='fecha'
                            defaultValue={
                                compra.fecha ?? formatDate(new Date())
                            }
                        />
                        {errors.fecha && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            Fecha Vencimiento:
                        </label>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha_vencimiento'
                            name='fecha_vencimiento'
                            defaultValue={
                                compra.fechaVencimiento ??
                                dayjs().add(30, "days").format("YYYY-MM-DD")
                            }
                        />
                        {errors.fecha_vencimiento && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha_vencimiento[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            No. Factura:
                        </label>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='numero'
                            name='numero'
                            defaultValue={compra.numero}
                        />
                        {errors.numero && (
                            <small className='help-blockParams form-Text'>
                                {errors.numero[0]}
                            </small>
                        )}
                    </div>

                    <div className='form-group col-md-2'>
                        <label className='label form-control-label'>NCF:</label>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='ncf'
                            name='ncf'
                            defaultValue={compra.ncf}
                        />
                        {errors.ncf && (
                            <small className='help-blockParams form-Text'>
                                {errors.ncf[0]}
                            </small>
                        )}
                    </div>

                    <div className='form-group col-md-2'>
                        <label className='label form-control-label'>ITBIS:</label>
                        <input type='hidden' name='total_itbis' value={totalitbis} />
                        <select
                            name="itbis"
                            className="form-control"
                            onChange={this.changeItbis}
                            defaultChecked={useItbis}
                        >
                            <option value="aplicado">Aplicado</option>
                            <option value="no-aplicado">Sin Aplicar</option>
                            <option value="no-aplica">N/A</option>
                        </select>
                    </div>

                    {almacenes.length > 0 && (
                        <div className='form-group col-md-2'>
                            <label className='label form-control-label'>
                                Almacén:
                            </label>
                            <select
                                name='almacen_id'
                                className='form-control'
                                defaultValue={
                                    almacenPrincipal
                                        ? almacenPrincipal.id
                                        : null
                                }>
                                <option value=''>- Seleccionar -</option>
                                {almacenes.map((almacen) => (
                                    <option key={almacen.id} value={almacen.id}>
                                        {almacen.nombre}
                                    </option>
                                ))}
                            </select>
                            {errors.almacen_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.almacen_id[0]}
                                </small>
                            )}
                        </div>
                    )}
                    <div className='form-group col-md-2'>
                        <label className='label form-control-label'>
                            Tipo:
                        </label>
                        <select
                            name='tipo'
                            defaultValue={compra.tipo}
                            className='form-control'>
                            <option value='Contado'>Contado</option>
                            <option value='Crédito'>Crédito</option>
                        </select>
                        {errors.tipo && (
                            <small className='help-blockParams form-Text'>
                                {errors.tipo[0]}
                            </small>
                        )}
                    </div>
                    <div className='col-md-12'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th className='text-left' width='35px'>
                                        No.
                                    </th>
                                    <th width='30%'>Item</th>
                                    <th width='110px'>Cantidad</th>
                                    <th width='150px'>
                                        {useItbis === 'no-aplicado' ? 'Precio' : 'Costo'}
                                    </th>
                                    <th width='78px'>% Desc.</th>
                                    <th width='14%'>Grupo</th>
                                    {itbis > 0 && (
                                        <th className='text-right'>ITBIS</th>
                                    )}
                                    <th className='text-right' width='12%'>
                                        {useItbis === 'no-aplicado' ? 'Costo' : 'Precio'}
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {compraItems.map((item, index) => (
                                    <ItemsCompra
                                        key={item.id}
                                        item={item}
                                        index={index}
                                        removeItem={this.removeItem}
                                        items={items}
                                        updateTotal={this.updateTotal}
                                        grupos={grupos}
                                        itbis={itbis}
                                        useItbis={useItbis}
                                    />
                                ))}
                                <tr>
                                    <td colSpan='9'>
                                        {errors["items"] && (
                                            <small className='help-blockParams form-Text'>
                                                {errors["items"][0]}
                                            </small>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan='9'
                                        style={{ border: 0, paddingTop: 0 }}
                                        className='text-right'>
                                        <button
                                            type='button'
                                            onClick={this.addItem}
                                            className='btn'>
                                            <i className='fas fa-plus' />{" "}
                                            Agregar Item
                                        </button>
                                    </td>
                                </tr>
                                {itbis > 0 && (
                                <tr>
                                    <td colSpan='7' className='text-right'>
                                        <strong className='label form-control-label'>
                                            Subtotal:
                                        </strong>
                                    </td>
                                    <td colSpan='2' className='text-right'>
                                        <input
                                            type='hidden'
                                            name='subtotal'
                                            value={subtotal}
                                        />
                                        {formatCurrency(subtotal)}
                                    </td>
                                </tr>
                                )}
                                {itbis > 0 && (
                                    <tr>
                                        <td colSpan='7' className='text-right'>
                                            <strong className='label form-control-label'>
                                                ITBIS:
                                            </strong>
                                        </td>
                                        <td colSpan='2' className='text-right'>
                                            {formatCurrency(totalitbis)}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td colSpan='7' className='text-right'>
                                        <strong className='label form-control-label'>
                                            Total:
                                        </strong>
                                    </td>
                                    <td colSpan='2' className='text-right'>
                                        <input
                                            type='hidden'
                                            name='pagado'
                                            value='0'
                                        />
                                        <input
                                            type='hidden'
                                            name='total'
                                            value={total}
                                        />
                                        {formatCurrency(total)}
                                        {errors.total && (
                                            <small className='help-blockParams form-Text'>
                                                {errors.total[0]}
                                            </small>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                    </div>
                    <div className='form-group col-md-12'>
                        <label className='label form-control-label'>
                            Nota:
                        </label>
                        <textarea
                            className='text-input form-control'
                            id='descripcion'
                            name='descripcion'
                            rows='4'
                            defaultValue={compra.descripcion}
                        />
                        {errors.descripcion && (
                            <small className='help-blockParams form-Text'>
                                {errors.descripcion[0]}
                            </small>
                        )}
                    </div>
                    <div className='page-footer text-right col-md-12'>
                        <button
                            type='button'
                            onClick={toggle}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        {saving ? (
                            <Loader type='small' />
                        ) : (
                            <button type='submit' className='btn btn-primary'>
                                Guardar
                            </button>
                        )}
                    </div>
                </form>
            </div>
        );
    }
}

export default withRouter(withRequest(Create));
